"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReturnCustomVoiceBaseVoice = void 0;
exports.ReturnCustomVoiceBaseVoice = {
    Ito: "ITO",
    Kora: "KORA",
    Dacher: "DACHER",
    Aura: "AURA",
    Finn: "FINN",
    Whimsy: "WHIMSY",
    Stella: "STELLA",
    Sunny: "SUNNY",
};
